import { PAGE_SIZES } from '@/constants/pagination';
import {
  buildCusipsQueryParams,
  type CusipsListRequest,
} from '@/modules/dataFeeds/utils/buildCusipsQueryParams';

export type UserExportColumn = {
  Label: string;
  Property: string;
  Type?: string;
};

export type UserExportRequestBody = {
  DataUrl: string;
  Token: string;
  Columns: UserExportColumn[];
  FileName: string;
  CurrentRole: string;
  ChildProperty?: string | null;
};

export const HOLDINGS_WO_CUSIPS_EXPORT_NAME = 'Unclassified';
export const HOLDINGS_WO_CUSIPS_EXPORT_FILENAME = `${HOLDINGS_WO_CUSIPS_EXPORT_NAME}.xls`;

export function buildHoldingsWithoutCusipsExportDataUrl(
  advisorGroupId: number,
  listArgs: CusipsListRequest,
): string {
  const params = buildCusipsQueryParams({
    ...listArgs,
    Page: 1,
    Limit: PAGE_SIZES.EXPORT,
  });
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    search.set(key, String(value));
  }
  search.set('IsExport', 'true');
  return `api/firm/advisorGroups/${String(advisorGroupId)}/holdingsWOCusips?${search.toString()}`;
}

export function buildHoldingsWithoutCusipsExportBody(args: {
  advisorGroupId: number;
  listArgs: CusipsListRequest;
  columns: UserExportColumn[];
  token: string;
  currentRole: string;
  fileName?: string;
}): UserExportRequestBody {
  return {
    DataUrl: buildHoldingsWithoutCusipsExportDataUrl(
      args.advisorGroupId,
      args.listArgs,
    ),
    Token: args.token,
    Columns: args.columns,
    FileName: args.fileName ?? HOLDINGS_WO_CUSIPS_EXPORT_NAME,
    CurrentRole: args.currentRole,
    ChildProperty: null,
  };
}
